import type { TranslationFunctions } from '$i18n/i18n-types';
import { traitIdToResourceId } from './consts';

export function getTraitName(LL: TranslationFunctions, traitId: number) {
  type Key = keyof TranslationFunctions['er']['traits']['names'];
  return LL.er.traits.names[traitId.toString() as Key]();
}

export function getTraitCategoryString(traitId: number) {
  // NOTE: id가 7ABCC01 꼴임을 상정. A: 분류, B: 핵심 ? 0 : 1, C: 종류
  const mappedTraitId = traitIdToResourceId[traitId];
  switch (Math.trunc(mappedTraitId / 10000)) {
    case 1:
      return 'Havoc';
    case 2:
      return 'Fortification';
    case 3:
      return 'Support';
  }

  return 'Support';
}
